// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__ev18o","modal":"Modal_modal__l66d1","slide-down":"Modal_slide-down__18Hog"};